import { FetchQuotesRequest, QuoteInfo } from '@breathelife/types';
import ApiService from './ApiService';

export async function getQuotes(data: FetchQuotesRequest): Promise<QuoteInfo> {
  const response = await ApiService.fetchQuotes(data);
  return response.data;
}
